import React from "react";

import { Box } from "@mui/material";

import LinkedinSignalMappingContent from "components/organisms/CRMs/LinkedinSignalDestination/LinkedinSignalMappingContent";
import MicrosoftBingMappingContent from "components/organisms/CRMs/MicrosoftBingDestination/MicrosoftBingMappingContent";
import GoogleAdsConversionMappingContent from "components/organisms/Destinations/GoogleAdsConversion/GoogleAdsConversionMappingContent";
import OpenAiAdsMappingContent from "components/organisms/Destinations/OpenAiAds/OpenAiAdsMappingContent";

/** Post-create event-to-conversion mapping step. */
const DestinationMappingView = ({ destinationCreation }) => {
    const { form, linkedin, microsoftBing, googleAds, openAi } =
        destinationCreation;

    return (
        <>
            {linkedin.isMappingOpen && (
                <LinkedinSignalMappingContent
                    conversions={linkedin.conversions}
                    events={linkedin.events}
                    autoMatchedEvents={linkedin.autoMatchedEvents}
                    selectedMappings={linkedin.mappings}
                    setSelectedMappings={linkedin.setMappings}
                />
            )}
            {microsoftBing.isMappingOpen && (
                <MicrosoftBingMappingContent
                    conversions={microsoftBing.conversions}
                    events={microsoftBing.events}
                    autoMatchedEvents={microsoftBing.autoMatchedEvents}
                    selectedMappings={microsoftBing.mappings}
                    setSelectedMappings={microsoftBing.setMappings}
                />
            )}
            {googleAds.isMappingOpen && (
                <GoogleAdsConversionMappingContent
                    type={form.destinationCode}
                    conversions={googleAds.conversions}
                    events={googleAds.events}
                    selectedMappings={googleAds.mappings}
                    setSelectedMappings={googleAds.setMappings}
                    loadError={googleAds.conversionsError}
                    onRetry={googleAds.retryConversions}
                />
            )}
            {openAi.isMappingOpen && (
                <OpenAiAdsMappingContent
                    conversions={openAi.conversions}
                    events={openAi.events}
                    selectedMappings={openAi.mappings}
                    setSelectedMappings={openAi.setMappings}
                    loadError={openAi.conversionsError}
                    onRetry={openAi.retryConversions}
                />
            )}
        </>
    );
};

export default DestinationMappingView;
